import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function usePdpPriceRedesignExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_PRICE_REDESIGN)
  return experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
}
